import type { Database } from '../../Database'
import type { AssignedUserRole } from '../../AssignedUserRole'

export const USER_API_PATHS = {
  getGrantedDatabases: 'user/granted-databases',
  getUserProfile: 'user/profile',
  invalidateCache: 'user/cache/invalidate',
  getAccessRoles: 'user/access-roles',
  getUserProfileImage: (userId: string) => `access-control/users/${userId}/profile-image`
}

/** Response returned when fetching databases that the current user has access to. */
export interface GetGrantedDatabasesResponse {
  databases: Omit<Database, 'isSelected'>[]
}

/** Represent a response object containing profile information about the current authorized request user. */
export interface GetUserProfileResponse {
  /** Gatship Cloud User ID in UUID format. */
  userId: string
  /** The ID of the home tenant. */
  homeTenantId: string
  /** The name of the home tenant. */
  homeTenantName: string
  /** Indicates whether the user is a tenant administrator. */
  isTenantAdmin: boolean
  /** Primary email. */
  email: string
  /** Primary mobile phone number in ITU-T E.164 telephone number format. Note that UI should present the number in E.123 format as it is more user-friendly. */
  mobilePhoneNumber?: string
  /** Full name of the user, which includes given name and surname. */
  fullName: string
  /** Initials or call name. */
  initials: string
  /** URL pointing to the profile image of the user. */
  profileImageUrl?: string
  /** The actor of the user. Is only set if the user is in a support session. */
  actor?: {
    /** The full name of the actor. */
    fullName: string
    /** The image url of the actor. */
    imageUrl: string
    /** The tenant id of the actor. */
    tenantId: string
    /** The name of the tenant. */
    tenantName: string
    /** The user id of the actor. */
    userId: string
  }
}

export interface GetUserAccessRolesResponse {
  /** All roles assigned to the user. */
  roles: AssignedUserRole[]
  /** A map of roles and permissions, where the key is the ID of the role, and the value a collection of permissions that applies to that role. */
  rolePermissionMap: Record<string, string[]>
}
